import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { TranslateService } from "@root/shared/service/translate.service";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

// interface Option {
//   label: string;
//   value: any;
//   select?: boolean;
// }

export const SIMPLE_MULTI_SELECT_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SimpleMultiSelectComponent),
  multi: true,
};

@Component({
  selector: "host-simple-multi-select",
  templateUrl: "./simple-multi-select.component.html",
  styleUrls: ["./simple-multi-select.component.scss"],
  providers: [SIMPLE_MULTI_SELECT_VALUE_ACCESSOR],
})
export class SimpleMultiSelectComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() listOfOption: Option[] = [];
  // @Input() initialValue: any[] = []; /** @deprecated */
  @Input() borderless = true;
  @Input() style;
  @Input() size: "small" | "large" | "default" = "default";
  @Input() placeholderKey = "word.select_option.placeholder.account";
  @Input() unitKey = "robot.table.word.accounts"; // @deprecated
  @Input() selectedKey = "component.cleaner_assign_picker.textview";
  @Input() allowReset = true;
  // @Output() onSelect: EventEmitter<Option[]> = new EventEmitter<Option[]>(); /** @deprecated */
  visible = false;
  listOfSelected: Set<any> = new Set();

  textView;

  _registerOnChange: (value: any) => void = (_: any) => {};

  constructor(private t: TranslateService) {}

  ngOnInit() {
    // this.listOfSelected = new Set(this.initialValue);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes["initialValue"] && changes["initialValue"].currentValue) ||
      (changes["listOfOption"] && changes["listOfOption"].currentValue)
    ) {
      // this.listOfSelected = new Set(this.initialValue);
      this.updateTextView();
    }
  }

  onClickItem(option: Option) {
    const value = option.value;
    if (this.listOfSelected.has(value)) {
      this.listOfSelected.delete(value);
    } else {
      this.listOfSelected.add(value);
    }
  }

  onVisibleChange(visible: boolean) {
    // if (visible) {
    //   this.listOfSelected = new Set(this.initialValue);
    // }
  }
  onCancel() {
    this.closePanel();
  }
  onConfirm() {
    // const selected = this.listOfOption.filter(option => this.listOfSelected.has(option.value));
    // console.log('selected: ', selected);
    // this.onSelect.emit(selected);

    // this.initialValue = Array.from(this.listOfSelected);
    const value = Array.from(this.listOfSelected);
    this.updateTextView();
    this.closePanel();

    this._registerOnChange(value);
  }

  onReset() {
    this.listOfSelected = new Set();

    this.onConfirm();
  }

  private updateTextView() {
    const p_e = () => this.t.syncGet(this.placeholderKey);
    const p_p = (p) =>
      this.selectedKey ? this.t.syncGet(this.selectedKey, { number: p }) : p + "个" + this.t.syncGet(this.unitKey);

    const size = this.listOfSelected.size;

    if (size === 0) {
      return (this.textView = p_e());
    }
    if (size > 1) {
      // return this.textView = `${size}个账号`
      return (this.textView = p_p(size));
    }
    const value = Array.from(this.listOfSelected)[0];

    const option = this.listOfOption.find((opt) => opt.value === value);
    this.textView = option ? option.label : p_e();
  }

  private closePanel() {
    this.visible = false;

    console.log("close panel: ", this.visible);
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(obj: any): void {
    this.listOfSelected = new Set(obj);
    this.updateTextView();
  }
}
